var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['day_item', {today: _vm.day.today}, {active: _vm.day.active}],attrs:{"day":_vm.day,"data-date":_vm.day.date,"data-day-id":_vm.day.id}},[_c('div',{staticClass:"day_item_number"},[_vm._v(" "+_vm._s(_vm.day.number)+" ")]),_c('div',{staticClass:"day_item_label"},[_vm._v(" "+_vm._s(_vm.day.labelShort)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }